<template>
    <div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Movimentação Mínima no Período</label>
                    <b-input-group>
                        <b-form-input
                            type="number"
                            v-model="quantidade"
                            :state="$v.quantidade.$error ? false : null"
                            @input.native="$v.quantidade.$touch()"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                            Quantidade para movimentação é obrigatório
                        </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>  
        <b-row>
            <b-col sm="12" md="6">
                <b-form-group
                    :state="$v.dataInicial.$error ? false : null"
                    invalid-feedback="Data Inicial é obrigatória"
                >
                    <label class="required">Data Inicial</label>
                    <date-picker
                        v-model="dataInicial"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                        @input.native="$v.dataInicial.$touch()"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group
                    :state="$v.dataFinal.$error ? false : null"
                    invalid-feedback="Data Final é obrigatória"
                >
                    <label class="required">Data Final</label>
                    <date-picker
                        v-model="dataFinal"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                        @input.native="$v.dataFinal.$touch()"
                    ></date-picker>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Unidade</label>
                    <b-form-select
                        :plain="true"
                        :options="unidadesDeMedida"
                        v-model="unidadeMedida"
                        value-field="id"
                        text-field="descricao"
                        :state="$v.unidadeMedida.$error ? false : null"
                        @input.native="$v.unidadeMedida.$touch()"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>  
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Descrição</label>
                    <b-form-textarea
                        v-model="descricao"
                        :rows="2"
                    ></b-form-textarea>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Observação</label>
                    <b-form-textarea
                        v-model="observacao"
                        :rows="2"
                    ></b-form-textarea>
                </b-form-group>
            </b-col>
        </b-row>
        <div class="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                @click.stop="confirmarSalvar()"
                class="ml-1"
                :disabled="desabilitarBtnSalvar"
            >
                Salvar
            </b-button>
        </div>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import MovimentacoesMinimasServicos from './MovimentacoesMinimasServicos'


export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        tipoOperacao: {
            type: String,
            default: () => ''
        },

        showModal: {
            type: Boolean,
            default: () => false
        },

        movimentacaoMinimaId: {
            type: String,
            default: () => ''
        },

        unidadesDeMedida: {
            type: Array
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            quantidade: '',          
            dataInicial: new Date(),
            dataFinal: new Date(),
            descricao: '',
            unidadeMedida: null,
            observacao: '',
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
            this.resetFormulario()
            this.$emit('modalFechado')
        },

        resetFormulario() {
            this.erros = []
            this.quantidade = ''          
            this.dataInicial = new Date()
            this.dataFinal = new Date()
            this.descricao = ''
            this.unidadeMedida = ''
            this.observacao = ''

            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            if (this.tipoOperacao == 'a') {
                this.obterMovimentacao()
            }
        },

        obterMovimentacao() {
            this.$store.dispatch('addRequest')
            MovimentacoesMinimasServicos.obterMovimentacao(
                this.contrato.idContrato,
                this.movimentacaoMinimaId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.quantidade = response.data.quantidade
                        this.dataInicial = this.$moment(
                            response.data.dataInicial
                        ).format('DD/MM/YYYY')
                        this.dataFinal = this.$moment(
                            response.data.dataFinal
                        ).format('DD/MM/YYYY')
                        this.descricao = response.data.descricao
                        this.unidadeMedida = response.data.unidadeMedida
                        this.observacao = response.data.observacao
                    } else {
                        this.$toast.error(
                            'Erro ao obter a movimentação',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarSalvar() {
            let msg
            if (this.tipoOperacao == 'i') {
                msg = 'Confirma a inserção da Movimentação Mínima?'
            } else {
                msg = 'Confirma a atualização da Movimentação Mínima?'
            }

            this.$swal({
                title: 'Movimentação Mínima',
                html: msg,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let movimentacaoDto = {
                contratoId: this.contrato.idContrato,
                quantidade: this.quantidade,
                dataInicial: this.dataInicial
                    ? this.$moment(this.dataInicial, 'DD/MM/YYYY').toISOString()
                    : '',
                dataFinal: this.dataFinal
                    ? this.$moment(this.dataFinal, 'DD/MM/YYYY').toISOString()
                    : '',
                descricao: this.descricao ? this.descricao : '',
                unidadeMedida: this.unidadeMedida ? this.unidadeMedida : '',
                observacao: this.observacao ? this.observacao : '',
            }

            let promisse
            if (this.tipoOperacao == 'i') {
                promisse = MovimentacoesMinimasServicos.inserir(movimentacaoDto)
            } else {
                movimentacaoDto = { ...movimentacaoDto, movimentacaoMinimaId: this.movimentacaoMinimaId }
                promisse = MovimentacoesMinimasServicos.atualizar(this.contrato.idContrato, this.movimentacaoMinimaId, movimentacaoDto)
            }

            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Operação realizada com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterMovimentacoesAtualizadas')
            this.fecharModal()
        },
    },

    created() {
        this.preencherForm()
    },

    computed: {
        operacao() {
            switch (this.tipoOperacao) {
                case 'i':
                    return 'INSERIR'
                case 'a':
                    return 'ATUALIZAR'
                default:
                    break
            }
        },

        desabilitarBtnSalvar() {
            return this.$v.$invalid
        }
    },

    watch: {
        showModal() {
            this.mostrarModal = this.showModal
        }
    },

    validations: {
        quantidade: { required },
        dataInicial: { required },
        dataFinal: { required },
        unidadeMedida: { required }
    }
}
</script>
<style scoped>
    .modal-footer {
        justify-content: flex-end;
        padding: 1rem 0 0 0;
        border-top: 1px solid #c8ced3;
    }
</style>